import Cookies from "js-cookie";

const AccessTokenKey = "Access-Token";
const RefreshTokenKey = "Refresh-Token";
const TokenExpirationKey = "Token-Expiration";
const UserDataKey = "User-Data";
const MobileAppKey = "Is-Mobile-App";

// Token expiration time in minutes
const TOKEN_EXPIRATION_TIME = 60;
const REFRESH_TOKEN_EXPIRATION_TIME = 24 * 60 * 30; // 30 days

function shouldUseSecureCookies() {
  if (typeof window !== "undefined" && window.location) {
    return window.location.protocol === "https:";
  }
  return process.env.NODE_ENV === "production";
}

export function getToken() {
  return Cookies.get(AccessTokenKey);
}

export function getValidToken() {
  // Check if token needs refresh before returning
  if (isTokenExpired()) {
    return null;
  }
  return Cookies.get(AccessTokenKey);
}

export function setToken(token, expirationTime) {
  if (!expirationTime) {
    console.error('Expiration time is required for token');
    return;
  }
  const expirationDate = new Date(expirationTime);
  if (isNaN(expirationDate.getTime())) {
    console.error('Invalid expiration time format');
    return;
  }
  setTokenExpiration(expirationTime);
  return Cookies.set(AccessTokenKey, token);
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token);
}

export function getTokenExpiration() {
  return Cookies.get(TokenExpirationKey);
}

export function setTokenExpiration(expiration) {
  return Cookies.set(TokenExpirationKey, expiration);
}

export function clearAuthData() {
  Cookies.remove(AccessTokenKey);
  Cookies.remove(RefreshTokenKey);
  Cookies.remove(TokenExpirationKey);
  Cookies.remove(UserDataKey);
  Cookies.remove(MobileAppKey);
}

export function isTokenExpired() {
  const expiration = getTokenExpiration();
  if (!expiration) return true;
  
  // Increase buffer time to 5 minutes to ensure refresh happens well before expiration
  const bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds
  return new Date().getTime() > (new Date(expiration).getTime() - bufferTime);
}

export function setUserData(userData) {
  const secure = shouldUseSecureCookies();
  Cookies.set(UserDataKey, JSON.stringify(userData), {
    secure,
    sameSite: secure ? "strict" : "lax",
  });
}

export function getUserData() {
  const data = Cookies.get(UserDataKey);
  return data ? JSON.parse(data) : null;
}

export function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

// Mobile app detection functions
export function setMobileApp(isMobileApp) {
  if (isMobileApp) {
    const secure = shouldUseSecureCookies();
    Cookies.set(MobileAppKey, 'true', {
      expires: 365, // 1 year
      secure,
      sameSite: secure ? 'strict' : 'lax'
    });
  } else {
    Cookies.remove(MobileAppKey);
  }
}

export function isMobileApp() {
  return Cookies.get(MobileAppKey) === 'true';
}
